import React, { useEffect, useState } from "react";
import { Box, makeStyles, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useDispatch, useSelector } from "react-redux";
import { actionTypes } from "../../../../../../../redux/bourse/select_manufacturer";


let useStyles = makeStyles((theme) => ({
    root: {
        width: "270px",
        height: 50,
        margin: 5,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        [theme.breakpoints.down("950")]: {
            minWidth: '48%',
        },
        [theme.breakpoints.down("700")]: {
            width: '100%',
        },
    },
    box: {
        margin: 0,
    }
}))

export default function Index({ handleChange, state }) {

    let classes = useStyles();
    let dispatch = useDispatch();
    const [value, setValue] = useState('');
    const [filteredOptions, setFilteredOptions] = useState([]);

    const stateReducer = useSelector((state) => state.bourse_select_manufacturer_reducer);


    const apiSubmit = () => {

        dispatch({
            type: actionTypes.selectManufacturerBourseAsync,
            payload: state['commodity_id']?.data?.commodity_id
                ? {
                    data: {
                        commodity_id: state['commodity_id']?.data?.commodity_id
                    },
                    // sort_by:'asc'
                    // sort_by:'desc'
                }
                : { 
                    // sort_by:'asc'
                },
        });
    };

    useEffect(() => {
        apiSubmit();
    }, [state['commodity_id']]);


    const handelChangeState = (event) => {

        const newFilteredOptions = stateReducer?.data.filter((option) =>
           option?.id?.toLowerCase()?.includes(event?.target?.value.toLowerCase())
        );

        setValue(event?.target?.value)
    }


    return (
        <div className={classes['root']}>

            <Box
                className={classes['box']}
                // marginBottom="30px"
                width="100%"
                height="50px"
            >
                <Autocomplete
                    size={"small"}
                    id="combo-box-demo"
                    // disabled={stateReducer.data ? false : true}
                    options={stateReducer?.data}
                    getOptionLabel={(option) => option.id}
                    value={state?.['manufacturer_id'] ? state?.['manufacturer_id'] : null}
                    onChange={(event, value) => handleChange(value, "manufacturer_id")}
                    onKeyUp={(event) => handelChangeState(event)}

                    noOptionsText={
                        stateReducer?.loading
                            ? "در حال بارگذاری..."
                            : filteredOptions?.length === 0
                                ? 'کالای یافت نشد'
                                : null
                    }
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="تولید کنندگان"
                            variant="outlined"
                        />
                    )}
                />
            </Box>
        </div>)
}
